import { Navigate, Outlet } from "react-router-dom";
import { isAuthenticated } from "routes/auth";
import { DEFAULT_APP_PATH } from "routes/paths";

export default function GuestRoute() {
  if (isAuthenticated()) {
    return <Navigate to={DEFAULT_APP_PATH} replace />;
  }

  return <Outlet />;
}
